import { computed, ref } from 'vue'

export type AuthUser = { id: string; nickname: string; avatarUrl?: string }
export type AuthSession = {
  accessToken: string
  refreshToken?: string
  encToken?: string
  user: AuthUser
}

const STORAGE_KEY = 'dingtennis_web_auth_v1'

function load(): AuthSession | null {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null')
    if (!value?.accessToken || !value?.user?.id) return null
    return value
  } catch {
    return null
  }
}

export const authState = ref<AuthSession | null>(load())
export const isLoggedIn = computed(() => Boolean(authState.value?.accessToken))

export function setAuth(session: AuthSession) {
  authState.value = session
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session))
}

export function clearAuth() {
  authState.value = null
  localStorage.removeItem(STORAGE_KEY)
}
